export default {
	tableList: {
		listStyleType: 'none',
		padding: 0,
	},
};
